import React from "react";
import { IconProps } from "./IconProps";

const ArrowCircleRightIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 3.25C13.4783 3.25 11.0132 3.99777 8.91648 5.39876C6.81975 6.79975 5.18555 8.79103 4.22053 11.1208C3.25552 13.4505 3.00302 16.0141 3.49499 18.4874C3.98695 20.9607 5.20127 23.2325 6.98439 25.0156C8.76751 26.7987 11.0393 28.0131 13.5126 28.505C15.9859 28.997 18.5495 28.7445 20.8792 27.7795C23.209 26.8144 25.2002 25.1802 26.6012 23.0835C28.0022 20.9868 28.75 18.5217 28.75 16C28.746 12.6197 27.4015 9.379 25.0112 6.98877C22.621 4.59854 19.3803 3.25397 16 3.25ZM16 27.25C13.775 27.25 11.5999 26.5902 9.74983 25.354C7.89978 24.1179 6.45784 22.3609 5.60635 20.3052C4.75487 18.2495 4.53208 15.9875 4.96616 13.8052C5.40025 11.6229 6.47171 9.61839 8.04505 8.04505C9.61839 6.47171 11.6229 5.40025 13.8052 4.96617C15.9875 4.53208 18.2495 4.75487 20.3052 5.60636C22.3609 6.45784 24.1179 7.89978 25.354 9.74984C26.5902 11.5999 27.25 13.775 27.25 16C27.2467 18.9827 26.0604 21.8422 23.9513 23.9513C21.8422 26.0604 18.9827 27.2467 16 27.25ZM21.53 15.47C21.6704 15.6106 21.7493 15.8012 21.7493 16C21.7493 16.1988 21.6704 16.3894 21.53 16.53L17.53 20.53C17.3878 20.6625 17.1998 20.7346 17.0055 20.7312C16.8112 20.7277 16.6258 20.649 16.4884 20.5116C16.351 20.3742 16.2723 20.1888 16.2688 19.9945C16.2654 19.8002 16.3375 19.6122 16.47 19.47L19.1887 16.75H11C10.8011 16.75 10.6103 16.671 10.4697 16.5303C10.329 16.3897 10.25 16.1989 10.25 16C10.25 15.8011 10.329 15.6103 10.4697 15.4697C10.6103 15.329 10.8011 15.25 11 15.25H19.1887L16.47 12.53C16.3375 12.3878 16.2654 12.1998 16.2688 12.0055C16.2723 11.8112 16.351 11.6258 16.4884 11.4884C16.6258 11.351 16.8112 11.2723 17.0055 11.2688C17.1998 11.2654 17.3878 11.3375 17.53 11.47L21.53 15.47Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default ArrowCircleRightIcon;
